import React, { useRef, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const OutlinedSelect = ({ classes, value, onChange, label, name, data }) => {
  const [width, changeWidth] = useState(0);
  const inputEl = useRef(null);
  useEffect(() => {
    const node = ReactDOM.findDOMNode(inputEl.current);
    if (node) {
      const widthEl = node.offsetWidth;
      changeWidth(widthEl);
    }
  });
  const id = `outlined-${name}-selector`;
  return (
      <FormControl fullWidth variant="outlined">
        <InputLabel ref={inputEl} htmlFor={id}>
          {label}
        </InputLabel>
        <Select
          value={value}
          onChange={onChange}
          input={<OutlinedInput labelWidth={width} name={name} id={id} />}
        >
          {data.map(item => {
            return (
              <MenuItem key={`${id}-${item.value}`} value={item.value}>
                {item.label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
  );
};

export default OutlinedSelect;



// WEBPACK FOOTER //
// ./src/components/forms/outlined-select.js